<div class="content-pre-loader">
  <mat-spinner diameter="54"></mat-spinner>
</div>
